import { useState } from 'react';
import SaveTheCatView from './SaveTheCatView';
import MICEView from './MICEView';
import McKeeView from './McKeeView';

const FRAMEWORKS = [
  { id: 'save-the-cat', name: 'Save the Cat', component: SaveTheCatView, color: 'green' },
  { id: 'mice', name: 'M.I.C.E. Quotient', component: MICEView, color: 'purple' },
  { id: 'mckee', name: 'McKee Structure', component: McKeeView, color: 'orange' },
];

export default function FrameworkTabs({ analyses, onBeatSelect, selectedBeat, onRewriteBeat }) {
  const [activeTab, setActiveTab] = useState('save-the-cat');

  const activeFramework = FRAMEWORKS.find(f => f.id === activeTab);
  const ActiveComponent = activeFramework?.component;
  const activeAnalysis = analyses?.find(a => a.framework === activeTab);

  // Don't render if no analyses available
  if (!analyses || analyses.length === 0) {
    return null;
  }

  return (
    <div className="mt-8">
      {/* Tab Navigation */}
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 mb-6">
        <div className="border-b border-slate-200">
          <nav className="flex space-x-8 px-6">
            {FRAMEWORKS.map(framework => {
              const hasAnalysis = analyses.some(a => a.framework === framework.id);
              if (!hasAnalysis) return null;

              return (
                <button
                  key={framework.id}
                  onClick={() => setActiveTab(framework.id)}
                  className={`py-4 px-2 border-b-2 font-medium text-sm transition-colors ${
                    activeTab === framework.id
                      ? `border-${framework.color}-500 text-${framework.color}-600`
                      : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'
                  }`}
                >
                  {framework.name}
                </button>
              );
            })}
          </nav>
        </div>

        {/* Framework Content */}
        <div className="p-6">
          {ActiveComponent && activeAnalysis && (
            <ActiveComponent
              analysis={activeAnalysis}
              onBeatSelect={onBeatSelect}
              selectedBeat={selectedBeat}
              onRewriteBeat={onRewriteBeat}
            />
          )}
        </div>
      </div>
    </div>
  );
}
